import { createGlobalStyle } from 'styled-components';

export const SearchBoxStyles = createGlobalStyle`
  [class*='ms-SearchBox'][class*='root-'] {
    border: none;
    border-radius: 3px;
  }
`;
